import React from 'react'
import { useMedia, useMemo } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'
import Text from 'components/_new/typography/Text/Text'
import Title from 'components/_new/typography/deprecated/Title/Title'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import messages from './messages'
import s from './GiftInfo.scss'

// resolve picture x2
import scentbirdImage from './images/scentbird-box.png'


const GiftPageGiftInfo = () => {
  const { isMobile } = useMedia()

  const alignPosition = useMemo(() => (
    isMobile ? 'center' : null
  ), [ isMobile ])

  return (
    <Box pt="48" pb="48">
      <WidthContainer className={s.container}>
        <div>
          <Title message={messages.title} align={alignPosition} size="lg" />
          <Text size="28-40" semibold message={messages.subTitle} color="brand" align={alignPosition} />
          {
            Object.keys(messages.info).map((name, index) => (
              <Box className={s.propertyContainer} key={index} mt={index ? '24' : '36'} pl="24">
                <Text message={messages.info[name]} uppercase />
              </Box>
            ))
          }
        </div>
        <Box mt="24" alignCenter>
          <Image className={s.picture} {...scentbirdImage} />
        </Box>
      </WidthContainer>
    </Box>
  )
}


export default GiftPageGiftInfo
